import { render, staticRenderFns } from "./MarketplaceConnectionCheck.vue?vue&type=template&id=3bdc2998"
import script from "./MarketplaceConnectionCheck.vue?vue&type=script&lang=js"
export * from "./MarketplaceConnectionCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports